var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRota(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1631_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0C4.85357 0 5.14286 0.295312 5.14286 0.65625V2.625H12.8571V0.65625C12.8571 0.295312 13.1464 0 13.5 0C13.8536 0 14.1429 0.295312 14.1429 0.65625V2.625H15.4286C16.8469 2.625 18 3.80215 18 5.25V6.5625V7.875V18.375C18 19.8229 16.8469 21 15.4286 21H2.57143C1.15313 21 0 19.8229 0 18.375V7.875V6.5625V5.25C0 3.80215 1.15313 2.625 2.57143 2.625H3.85714V0.65625C3.85714 0.295312 4.14643 0 4.5 0ZM16.7143 7.875H1.28571V18.375C1.28571 19.101 1.86027 19.6875 2.57143 19.6875H15.4286C16.1397 19.6875 16.7143 19.101 16.7143 18.375V7.875ZM15.4286 3.9375H2.57143C1.86027 3.9375 1.28571 4.52402 1.28571 5.25V6.5625H16.7143V5.25C16.7143 4.52402 16.1397 3.9375 15.4286 3.9375ZM3.85714 15.0938C3.85714 14.7328 4.14643 14.4375 4.5 14.4375H9.64286C9.99643 14.4375 10.2857 14.7328 10.2857 15.0938C10.2857 15.4547 9.99643 15.75 9.64286 15.75H4.5C4.14643 15.75 3.85714 15.4547 3.85714 15.0938ZM4.5 10.5H13.5C13.8536 10.5 14.1429 10.7953 14.1429 11.1562C14.1429 11.5172 13.8536 11.8125 13.5 11.8125H4.5C4.14643 11.8125 3.85714 11.5172 3.85714 11.1562C3.85714 10.7953 4.14643 10.5 4.5 10.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1631_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRota);
export default __webpack_public_path__ + "static/media/rota.984380e7110e33244c2559b70afc943c.svg";
export { ForwardRef as ReactComponent };